import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { IconButton, Popover, Stack, Typography } from '@mui/material'
import { type FC, type MouseEvent, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { templateIconTypes } from 'src/constants/templateIconTypes'
import type { RootState } from 'src/state/store'
import PopoverIcon from './PopoverIcon'
import TemplateIcon from './TemplateIcon'

const IconRow: FC = () => {
  const templateIcons = useSelector(
    (state: RootState) => state.templatesState.editTemplate.icons,
    shallowEqual,
  )
  const activeIconState = useState<number>(0)
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleOpenPopover = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClosePopover = () => {
    setAnchorEl(null)
  }

  return (
    <Stack spacing={1} sx={{ mx: 2 }}>
      <Typography variant="subtitle1">ひな形の種類</Typography>
      <Stack direction="row" alignItems="center" spacing={2}>
        {templateIcons.map(selectedTemplateIcon => (
          <TemplateIcon
            key={selectedTemplateIcon.iconType}
            {...{ activeIconState, selectedTemplateIcon }}
          />
        ))}
        <IconButton
          aria-label="ひな形の種類を追加"
          onClick={handleOpenPopover}
          data-testid="add-template-type-icon"
          sx={{ p: 0 }}
        >
          <AddCircleOutlineIcon
            sx={{ width: 44, height: 44, color: 'primary.main' }}
          />
        </IconButton>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
          transformOrigin={{ vertical: 'center', horizontal: 'left' }}
          data-testid="template-type-icon-popover"
        >
          <Stack direction="row" sx={{ p: 1 }} spacing={2}>
            {templateIconTypes.map(templateIcon => (
              <PopoverIcon key={templateIcon.value} {...{ templateIcon }} />
            ))}
          </Stack>
        </Popover>
      </Stack>
    </Stack>
  )
}

export default IconRow
